import $ from 'jquery';
import Util from 'root/module/util';
import View from 'view/base';
import View_Emoji from 'view/emoji';

export default View.extend({
    className: 'comment-inline-edit',

    views: {
        emoji: {}
    },

    events: {
        'click .emoji-launcher' : 'onOpenEmoji',
        'keyup .comment'        : 'onStoreSelection',
        'click .comment'        : 'onStoreSelection'
    },

    dom_handlers: {
        onOpenEmoji: function(e) {
            if (!(this.views.emoji instanceof View_Emoji)) {
                this.views.emoji = new View_Emoji({
                    onSelect: this.onEmojiSelect.bind(this),
                    launcher: this.$el.find('.emoji-launcher')
                });

                this.views.emoji.load();
                this.views.emoji.render().$el.hide().appendTo(this.$el.find('.region-emoji'));
            }

            this.views.emoji.toggle();
        },

        onStoreSelection: function(e) {
            try {
                this.comment_selection = window.getSelection().getRangeAt(0);
            } catch(e) {
                this.comment_selection = null;
            }
        }
    },

    initialize: function() {
    },

    getComment: function() {
        var comment = this.$el.find('.comment').html();

        var temp_element = $('<div>').html(comment);
        temp_element.find('.at-name').each(function() {
            var user_id = $(this).attr('userid');
            this.outerHTML = '@@:' + user_id + ':' + $(this).text() + '@@';
        });

        comment = temp_element.html();
        comment = Util.sanitizeContenteditable(comment);
        comment = comment.trim();

        return comment;
    },

    onEmojiSelect: function(emoji) {
        this.focus();

        var _fallback = function() {
            var comment = this.$el.find('.comment').html();
            comment = comment.replace(/<br>$/, '');
            comment += emoji;
            this.$el.find('.comment').html(comment);
            this.placeCaretAtEnd();
        }.bind(this);

        if (this.comment_selection) {
            try {
                this.comment_selection.deleteContents();
                this.comment_selection.insertNode(document.createTextNode(emoji));
                this.comment_selection.collapse(false);

                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(this.comment_selection);
            } catch (e) {
                _fallback();
            }
        } else {
            _fallback();
        }

        this.views.emoji.hide();
    },

    placeCaretAtEnd: function() {
        var el = this.$el.find('.comment').get(0);

        el.focus();

        if (typeof window.getSelection != 'undefined' && typeof document.createRange != 'undefined') {
            var range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof document.body.createTextRange != 'undefined') {
            var textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    },

    focus: function() {
        this.$el.find('.comment').focus();
    },

    render: function() {
        var comment = Util.nl2br(this.model.escape('comment'));
        comment = Util.parseComment(comment);

        var content =
        '<div class="comment" contenteditable="true">' + comment + '</div>' +
        '<div class="region-emoji"></div>' +
        '<div class="emoji-launcher"><span><i class="far fa-smile" style="pointer-events:none;"></i></span></div>';

        this.$el.html(content);

        setTimeout(function() {
            this.focus();
        }.bind(this), 100);

        return this;
    }
});